

interface KeybindsPanelProps {
  isVisible: boolean;
}

export const KeybindsPanel = ({ isVisible }: KeybindsPanelProps) => {
  const keybinds = [
    { key: 'Left Drag', action: 'Rotate view' },
    { key: 'Right Drag', action: 'Pan view' },
    { key: 'Scroll', action: 'Zoom in/out' },
    { key: 'Ctrl+Drag', action: 'Snap to side views' },
    { key: 'R', action: 'Reset view' },
    { key: 'F', action: 'Focus on model' },
    { key: '1-6', action: 'Snap to preset view' },
    { key: 'Double Click', action: 'Focus on point' },
    { key: 'B', action: 'Box-select zoom' },
  ];

  if (!isVisible) return null;

  return (
    <div class="visualizer-panel visualizer-keybinds-panel" style={{ display: 'block' }}>
      <div class="visualizer-panel-title">Keyboard Shortcuts</div>
      <div class="visualizer-keybinds-list">
        {keybinds.map(kb => (
          <div key={kb.key} class="visualizer-keybind-item">
            <span class="visualizer-keybind-key">{kb.key}</span>
            <span class="visualizer-keybind-action">{kb.action}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
